module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/60fc7acc624571cfa9d250d7d5cff041.svg";